import { render } from "./AddFilePage.vue?vue&type=template&id=bb475ed0"
import script from "./AddFilePage.vue?vue&type=script&lang=js"
export * from "./AddFilePage.vue?vue&type=script&lang=js"

import "./AddFilePage.vue?vue&type=style&index=0&id=bb475ed0&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__